import { QUESTION_TYPE } from "../../_constants/individualFields.constant";
import CustomSelectField from "./QuestionElement/CustomSelectField";
import CustomTextField from "./QuestionElement/CustomTextField";
import CustomCheckboxField from "./QuestionElement/CustomCheckboxField";
import CustomTextareaField from "./QuestionElement/CustomTextareaField";
import CustomNumericField from "./QuestionElement/CustomNumericField";

export const DYNAMIC_QUESTION_ELEMENT = {
    [QUESTION_TYPE.TEXT] : CustomTextField,
    [QUESTION_TYPE.NUMBER]: CustomNumericField,
    [QUESTION_TYPE.SELECT]: CustomSelectField,
    [QUESTION_TYPE.CHECKBOX]: CustomCheckboxField,
    [QUESTION_TYPE.TEXTAREA]: CustomTextareaField
}